module.exports = __webpack_public_path__ + "img/17.acc1c3e9.svg";